export default "__VITE_ASSET__BeewCdjA__"